
import '../css/Navbar.css';
function Navbar()  {
    return (
        <div>
            <div className="navbox">
            <img src="/Altius_Logo.png" alt="Logo" className="Logo" />
            </div>
        </div>
    )

}

export default Navbar;